import { useState } from "react";
import WaitlistModal from "../custom-components/Waitlist";

export default function IndexSectionCtaLightReverse5() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <section className="py-10 bg-gray-50 overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="py-16 px-8 text-center bg-blue-500 rounded-3xl">
            <div className="md:max-w-lg mx-auto">
              <h2 className="font-heading mb-6 text-4xl md:text-5xl text-white font-black tracking-tight">
                Join the waitlist
              </h2>
              <p className="mb-10 text-xl text-blue-100 font-bold">
                All feedback welcome. We would love to work with you to make FilingIQ the tool your firm actually wants!
              </p>
              <div className="flex flex-wrap justify-center -m-2 mb-4">
                <div className="w-auto p-2">
                  <button
                    className="block w-full px-8 py-3.5 text-lg text-center text-white font-bold bg-gray-900 hover:bg-gray-800 focus:ring-4 focus:ring-gray-600 rounded-full"
                    onClick={() => setModalOpen(true)}
                  >
                    Join here
                  </button>
                </div>
              </div>
              <p className="text-xs text-blue-100">No credit card required.</p>
            </div>
          </div>
        </div>
      </section>
      <WaitlistModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
